
<template>
  <!-- 音频说法详情页 -->
  <div class="audioimdet">
    <div class="w12 between">
      <lvbreadcrumb class="speltmbx" :tolist="tolist" />
      <div class="articdetlef">
        <audiozw :audioinfo="audioinfo"/>
        <audiogolawer :list="jinxyylist" />
      </div>
      <div class="articdetrig">
        <detlawbrinfo class="bgff" />
        <detrecomvideo class="bgff mt30" :list="tjvideolist" />
      </div>
    </div>
  </div>
</template>

<script>
import audiozw from "./child/audiozw";
import audiogolawer from "./child/audiogolawer";
import detlawbrinfo from "views/articimdet/components/detlawbrinfo";
import detrecomvideo from "views/articimdet/components/detrecomvideo";
import lvbreadcrumb from "components/content/lvbreadcrumb/lvbreadcrumb";

export default {
  components: {
    audiozw,
    audiogolawer,
    detlawbrinfo,
    detrecomvideo,
    lvbreadcrumb,
  },
  data: () => ({
    audioinfo:{},
    jinxyylist:[],
    tjvideolist:[],
  }),
  computed: {
    tolist() {
      return [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "音频说法",
          path: "/laws/audioclaim",
        },
        {
          name: this.audioinfo.title || "",
        },
      ];
    },
  },
  beforeMount() {
    this.getaudioinfo();
    this.getaudiolist()
    this.getvideolist();
  },
  methods: {
    getaudioinfo() {
      let data = {
        id: this.$route.query.audioinId,
      };
      this.$http.laws.getaudiocontent(data).then((res) => {
        this.audioinfo = res.data;
      });
    },
    
    getvideolist() {
      let data = {
        limit: 5,
        order: "hot",
        page: 1,
      };
      this.$http.laws.getvideolist(data).then((res) => {
        this.tjvideolist = res.data.data;
      });
    },
    getaudiolist() {
      let data = {
        limit: 4,
        page: 1,
        order: "hot",
      };
      this.$http.laws.getaudiolist(data).then((res) => {
        this.jinxyylist = res.data.data;
      });
    },
  },
  
  watch: {
    $route(to, from) {
    this.getaudioinfo();
    this.getaudiolist()
    this.getvideolist();
    },
  },
};
</script>

<style lang="scss" scoped>
.audioimdet {
  background-color: #f8f8f8;
  .w12 {
    width: 1200px;
    padding: 50px 0;
    margin: 0 auto;
    position: relative;
    align-items: flex-start;
    .bgff {
      background: #ffffff;
    }
    .articdetlef {
      width: 856px;
      background: #ffffff;
    }
    .articdetrig {
      width: 314px;
    }
  }
  .speltmbx {
    position: absolute;
    top: 20px;
    left: 0;
  }
}
</style>